import React, { useState, useEffect } from 'react';
import { FiSearch, FiCopy, FiPackage } from 'react-icons/fi';
import Modal from '../UI/Modal';
import { LoadingGrid } from '../UI/Loading';
import { productosService, formulacionesService } from '../../services';

const DuplicarFormulacionModal = ({ isOpen, onClose, onSelectFormulacion }) => {
  const [formulaciones, setFormulaciones] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedFormulacion, setSelectedFormulacion] = useState(null);

  useEffect(() => {
    if (isOpen) {
      loadFormulaciones();
    }
  }, [isOpen]);

  const loadFormulaciones = async () => {
    setLoading(true);
    try {
      // Obtener todas las formulaciones
      const response = await formulacionesService.getFormulaciones({
        limit: 100,
        is_active: true
      });

      if (response.success && response.data) {
        setFormulaciones(response.data);
      }
    } catch (error) {
      console.error('Error cargando formulaciones:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSelectFormulacion = async (formulacion) => {
    setSelectedFormulacion(formulacion);
    setLoading(true);

    try {
      // Obtener los detalles completos de la formulación
      const response = await formulacionesService.getFormulacion(formulacion.id);

      if (response.success && response.data) {
        // Pasar la formulación al componente padre
        onSelectFormulacion(response.data);
        onClose();
      } else {
        alert('Error al cargar los detalles de la formulación');
      }
    } catch (error) {
      console.error('Error cargando formulación completa:', error);
      alert('Error al cargar la formulación seleccionada');
    } finally {
      setLoading(false);
      setSelectedFormulacion(null);
    }
  };

  // Filtrar formulaciones por búsqueda y excluir EXCLUSIVAS (no se pueden duplicar)
  const formulacionesFiltradas = formulaciones
    .filter(formulacion => formulacion.formula_type !== 'EXCLUSIVE')
    .filter(formulacion =>
      formulacion.formula_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      formulacion.company_name?.toLowerCase().includes(searchTerm.toLowerCase())
    );

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Duplicar Formulación"
      size="large"
    >
      <div style={{ padding: '0 8px' }}>
        {/* Buscador */}
        <div style={{ marginBottom: '20px' }}>
          <div style={{ position: 'relative' }}>
            <FiSearch style={{
              position: 'absolute',
              left: '12px',
              top: '50%',
              transform: 'translateY(-50%)',
              color: '#888',
              fontSize: '18px'
            }} />
            <input
              type="text"
              className="form-input"
              placeholder="Buscar por nombre de fórmula o compañía..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{ paddingLeft: '40px' }}
              autoFocus
            />
          </div>
        </div>

        {/* Lista de formulaciones */}
        {loading ? (
          <LoadingGrid />
        ) : formulacionesFiltradas.length > 0 ? (
          <div style={{
            maxHeight: '400px',
            overflowY: 'auto',
            border: '1px solid #e0e0e0',
            borderRadius: '8px'
          }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead style={{
                position: 'sticky',
                top: 0,
                backgroundColor: '#7B2D8E',
                color: 'white',
                zIndex: 1
              }}>
                <tr>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #6a2679' }}>
                    Nombre de Fórmula
                  </th>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #6a2679' }}>
                    Compañía
                  </th>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #6a2679' }}>
                    Tipo
                  </th>
                  <th style={{ padding: '12px', textAlign: 'center', borderBottom: '2px solid #6a2679' }}>
                    Acción
                  </th>
                </tr>
              </thead>
              <tbody>
                {formulacionesFiltradas.map((formulacion) => (
                  <tr
                    key={formulacion.id}
                    style={{
                      borderBottom: '1px solid #e0e0e0',
                      backgroundColor: selectedFormulacion?.id === formulacion.id ? '#f0e6f3' : 'white',
                      transition: 'background-color 0.2s'
                    }}
                    onMouseEnter={(e) => {
                      if (selectedFormulacion?.id !== formulacion.id) {
                        e.currentTarget.style.backgroundColor = '#f9f9f9';
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (selectedFormulacion?.id !== formulacion.id) {
                        e.currentTarget.style.backgroundColor = 'white';
                      }
                    }}
                  >
                    <td style={{ padding: '12px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <FiPackage style={{ color: '#7B2D8E', fontSize: '18px' }} />
                        <span style={{ fontWeight: '500' }}>{formulacion.formula_name || 'Sin nombre'}</span>
                      </div>
                    </td>
                    <td style={{ padding: '12px', color: '#666' }}>
                      {formulacion.company_name || 'N/A'}
                    </td>
                    <td style={{ padding: '12px', color: '#666' }}>
                      {formulacion.formula_type || 'N/A'}
                    </td>
                    <td style={{ padding: '12px', textAlign: 'center' }}>
                      <button
                        className="btn btn--sm btn--primary"
                        onClick={() => handleSelectFormulacion(formulacion)}
                        disabled={selectedFormulacion?.id === formulacion.id}
                        style={{
                          backgroundColor: '#7B2D8E',
                          borderColor: '#7B2D8E',
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: '6px'
                        }}
                      >
                        <FiCopy /> Duplicar
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div style={{
            padding: '40px',
            textAlign: 'center',
            color: '#888',
            backgroundColor: '#f9f9f9',
            borderRadius: '8px'
          }}>
            {searchTerm ? (
              <>
                <FiSearch style={{ fontSize: '48px', marginBottom: '12px', opacity: 0.5 }} />
                <p>No se encontraron formulaciones con el término "{searchTerm}"</p>
              </>
            ) : (
              <>
                <FiPackage style={{ fontSize: '48px', marginBottom: '12px', opacity: 0.5 }} />
                <p>No hay formulaciones disponibles</p>
              </>
            )}
          </div>
        )}

        {/* Footer con información */}
        <div style={{
          marginTop: '20px',
          padding: '12px',
          backgroundColor: '#f0f7ff',
          borderRadius: '6px',
          border: '1px solid #b3d9ff',
          fontSize: '0.9em',
          color: '#0066cc'
        }}>
          <strong>Nota:</strong> Al duplicar una formulación, todos los datos (ingredientes, cantidades, configuración)
          se copiarán al formulario actual. Podrás modificar lo que necesites antes de guardar.
        </div>
      </div>
    </Modal>
  );
};

export default DuplicarFormulacionModal;
